export function getFlashcardLink({ genreSlug, categorySlug, id }) {
  return `/media/flashcards/${genreSlug}/${categorySlug}${
    id ? `?flashcard=${id}` : ''
  }`
}

export function getLessonLink({ lessonSectionSlug, slug, isUserLoggedIn }) {
  if (isUserLoggedIn) {
    return `/lesson/${slug}`
  }

  return `/lessons/${lessonSectionSlug}/${slug}`
}

export function getPostLink({ slug }) {
  return `/blog/${slug}`
}

export function getCollectionLink({ listCategorySlug, slug }) {
  return `/collections/${listCategorySlug}/${slug}`
}

export function getVideoLink({ slug }) {
  return `/video/${slug}`
}

export function getPollLink({ slug }) {
  return `/gather/ellii-polls/${slug}`
}

export function getCourseLink({ slug }) {
  return `/packs/${slug}`
}

export function getStudyPack({ slug }) {
  return `/packs/${slug}`
}
